'use client'

import React from 'react'

export default function Testimonials() {
  const testimonials = [
    {
      name: 'María González',
      location: 'Bogotá',
      rating: 5,
      text: 'La mejor experiencia de mi vida. Los instructores son super profesionales y las vistas son increíbles. ¡Definitivamente lo volvería a hacer!',
      flight: 'Vuelo PRO MAX',
      date: 'Abril 2026'
    },
    {
      name: 'Carlos Rodríguez',
      location: 'Medellín',
      rating: 5,
      text: 'Regalé el vuelo Pro Max para el cumpleaños de mi esposa y fue lo mejor. El video quedó espectacular. El equipo de Airlovers hizo que todo fuera perfecto.',
      flight: 'Cumpleaños PRO MAX',
      date: 'Marzo 2026'
    },
    {
      name: 'Andrea López',
      location: 'Cali',
      rating: 5,
      text: 'Tenía mucho miedo pero el instructor me dio mucha confianza. El vuelo duró 22 minutos y fue increíble. Las vistas del embalse son preciosas. 100% recomendado.',
      flight: 'Vuelo MAX',
      date: 'Abril 2026'
    },
    {
      name: 'Julián Ramírez',
      location: 'Bucaramanga',
      rating: 5,
      text: 'Hice el vuelo de acrobacias y fue una locura! Los delfines y las barrenas son increíbles. El video GoPro capturó todo. Vale cada peso.',
      flight: 'Vuelo PRO MAX',
      date: 'Marzo 2026'
    },
    {
      name: 'Carolina Méndez',
      location: 'Bogotá',
      rating: 5,
      text: 'Celebramos nuestro aniversario volando y fue mágico. La decoración en tierra, el vuelo, todo fue perfecto. Gracias Airlovers por este recuerdo inolvidable.',
      flight: 'Aniversario MAX',
      date: 'Febrero 2026'
    },
    {
      name: 'Andrés Felipe Torres',
      location: 'Bogotá',
      rating: 5,
      text: 'Excelente servicio desde el principio. La reserva fue fácil, el lugar es hermoso y los pilotos muy profesionales. Ya estoy planeando volver con mis amigos.',
      flight: 'Vuelo Clásico',
      date: 'Abril 2026'
    }
  ]

  return (
    <section className="py-20 bg-gradient-to-b from-black/80 to-blue-900/30 relative z-20">
      <div className="container mx-auto px-4 relative z-30">
        {/* Header */}
        <div className="text-center mb-16 relative z-30">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            LO QUE DICEN NUESTROS CLIENTES
          </h2>
          <p className="text-xl text-white/90 mb-8 font-medium drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            Más de 15,000 vuelos realizados con clientes felices
          </p>
          
          {/* Rating Promedio */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="w-8 h-8 text-yellow-400 fill-current" viewBox="0 0 20 20">
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                </svg>
              ))}
            </div>
            <span className="text-3xl font-bold text-white">4.9/5</span>
            <span className="text-white/70">(127 reseñas verificadas)</span>
          </div>
        </div>

        {/* Testimonios Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:border-white/40 transition-all duration-300 hover:transform hover:scale-105"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
                    <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                  </svg>
                ))}
              </div>

              {/* Texto */}
              <p className="text-white/90 text-lg mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Info Cliente */}
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-bold text-white">{testimonial.name}</div>
                  <div className="text-white/60 text-sm">{testimonial.location}</div>
                </div>
                <div className="text-right">
                  <div className="text-green-400 font-bold text-sm">{testimonial.flight}</div>
                  <div className="text-white/50 text-xs">{testimonial.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA para dejar reseña */}
        <div className="mt-16 text-center">
          <p className="text-white/80 mb-6">
            ¿Ya volaste con nosotros? ¡Cuéntanos tu experiencia!
          </p>
          <a
            href="https://goo.gl/maps/your-google-business-link"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-white/20 hover:bg-white/30 text-white font-bold py-3 px-6 rounded-full transition-all duration-300"
          >
            <span className="mr-2">⭐</span>
            <span>Dejar reseña en Google</span>
          </a>
        </div>
      </div>
    </section>
  )
}
